import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Toast from '../components/Toast';

const Login = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = (e) => {
    e.preventDefault();
    setLoading(true);
    if (username && password) {
      fetch(`${process.env.REACT_APP_SERVER_URL}/users/login`, 
        {
          method: "POST",
          body: JSON.stringify({username, password}),
          headers: {
            "Content-Type": "application/json"
          }
        }
      )
      .then(r => r.json())
      .then(res => {
        setLoading(false);
        if (res.type === "error") {
          return Toast.fire({icon: "error", title: res.message});
        }
        window.sessionStorage.setItem("usrtk", res.token);
        Toast.fire({icon: "success", title: "Logged in successfully!"})
        .then(() => navigate('/dashboard'));
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
        Toast.fire({icon: "error", title: "Server error"});
      })
    } else {
        setLoading(false);
        Toast.fire({icon: "error", title: "Please enter both username and password"});
    }
  };

  return (
    <div className="container">
      <h1>Login</h1>
      <form onSubmit={handleLogin} className='login'>
        <label>Username:</label>
        <input
          type="text"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />

        <label>Password:</label>
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />

        <button type="submit">{loading ? "logging in..." : "Login"}</button>
      </form>
    </div>
  );
};

export default Login;
